export default "__VITE_ASSET__BAhBl2mP__"